import { required } from 'vuelidate/lib/validators';

const validations = {
  title: {
    required
  },
  description: {
    required
  },
};

export default validations;